export const DASHBOARD_ORDERS = {
	ORDERED: 'Ordered',
	SHIPPED: 'Shipped',
	IN_PROGRESS: 'In Progress',
	ALERT: 'Alert',
};

export const STATUSES = {
	Ordered: {
		progress: 1,
	},
	'In Progress': {
		progress: 2,
	},
	Shipped: {
		progress: 3,
	},
	Alert: {
		progress: 1,
		color: (theme) => theme.palette.danger.main,
	},
	Delivered: {
		progress: 4,
	},
	Invoiced: {
		progress: 1,
	},
	Cancelled: {
		progress: 0,
	},
};

export const STEPS_PROGRESS = {
	Ordered: {
		progress: 0,
		color: (theme) => theme.palette.statuses.success,
	},
	'In Progress': {
		progress: 1,
		color: (theme) => theme.palette.statuses.success,
	},
	Shipped: {
		progress: 2,
		color: (theme) => theme.palette.statuses.success,
	},
	Delivered: {
		progress: 3,
		color: (theme) => theme.palette.statuses.success,
	},
	Invoiced: {
		progress: 4,
		color: (theme) => theme.palette.statuses.success,
	},
	Alert: {
		progress: 1,
		color: (theme) => theme.palette.statuses.danger,
	},
	Cancelled: {
		progress: 5,
		color: (theme) => theme.palette.statuses.danger,
	},
};

export const ORDER_STATUS_SORT = [
	'Ordered',
	'Alert',
	'In Progress',
	'Shipped',
	'Delivered',
	'Invoiced',
	'Cancelled',
];

export const SORTKEYS = {
	PO: 'PO_Number',
	Status: 'Order_Status',
};
